import { PrismicRichText } from "@prismicio/react";
import HubspotForm from "../components/HubspotForm";
import React from "react";


export default function CustomRichText({ content }) {
    return content.map((block, index) => {
      const text = block.text?.trim();
  
      if (
        block.type === "paragraph" &&
        (text === "<!-- HUBSPOT_FORM -->" || text === "[hubspot-form]")
      ) {
        return <HubspotForm key={`hubspot-form-${index}`} />;
      }
  
      return <PrismicRichText key={index} field={[block]} />;
    });
  }
  